import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-viewer-for-editor',
  templateUrl: './image-viewer-for-editor.component.html',
  styleUrls: ['./image-viewer-for-editor.component.scss']
})
export class ImageViewerForEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
